import axios from 'axios';
import { GET_BANQUE_VERSEMENTS, ADD_BANQUE_VERSEMENT, DELETE_BANQUE_VERSEMENT, BANQUE_VERSEMENTS_LOADING, CLEAR_BANQUE_VERSEMENTS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IBanqueVersement } from '../../types/interfaces';

export const getBanqueVersements = (projectId: number, projectName: string) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: BANQUE_VERSEMENTS_LOADING
  });
  axios
    .get('/api/banqueversements', {...tokenConfig(getState), params: {projectId, projectName}})
    .then(res =>
      dispatch({
        type: GET_BANQUE_VERSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getAllBanqueVersements = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: BANQUE_VERSEMENTS_LOADING
  });
  axios
    .get('/api/banqueversements/all', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_BANQUE_VERSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getBanqueVersementsBySocieteGroup = (projectIds: number[], projectNames: string[]) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: BANQUE_VERSEMENTS_LOADING
  });
  axios
    .get('/api/banqueversements/bySocieteGroup', {...tokenConfig(getState), params: {projectIds, projectNames}})
    .then(res =>
      dispatch({
        type: GET_BANQUE_VERSEMENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addBanqueVersement = (banqueversement: IBanqueVersement) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/banqueversements', banqueversement, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: ADD_BANQUE_VERSEMENT,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const deleteBanqueVersement = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/banqueversements/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_BANQUE_VERSEMENT,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setBanqueVersementsLoading = () => {
  return {
    type: BANQUE_VERSEMENTS_LOADING
  };
};

export const clearBanqueVersements = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_BANQUE_VERSEMENTS
  })
};